(function () {
    function processInlineSvgs(root = document) {
      const inlineSvgTargets = root.querySelectorAll('[data-inline-svg]:not([data-inline-svg-loaded])');

      inlineSvgTargets.forEach((el) => {
        const src = el.getAttribute('data-src');
        if (!src) return;

        // Mark as loading so we never double-fetch this element
        el.setAttribute('data-inline-svg-loaded', 'true');

        fetch(src)
          .then((response) => {
            if (!response.ok) throw new Error('Failed to load SVG');
            return response.text();
          })
          .then((svgText) => {
            el.innerHTML = svgText;
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }

    function processCustomOptionsValue(root = document) {

        // Normalize root
        const productPages = root.matches?.('product-page')
            ? [root]                       // root is already product-page
            : root.querySelectorAll('product-page'); // root is document or other container

        productPages.forEach(productPage => {

            const form = productPage.querySelector('form[action*="/cart/add"]');
            if (!form) return;

            const customOptionsGroups = productPage.querySelectorAll('[data-ele="custom-options"]');

            customOptionsGroups.forEach(group => {
                /*
                const checkedRadio = group.querySelector('input[type="radio"]:checked');
                if (!checkedRadio) return;

                const propertyLabel = group.dataset.label || checkedRadio.name;
                */

                let selectedValue = null;
                let propertyLabel = null;

                // RADIO
                const checkedRadio = group.querySelector('input[type="radio"]:checked');
                if (checkedRadio) {
                    selectedValue = checkedRadio.value;
                    propertyLabel = group.dataset.label || checkedRadio.name;
                }

                // SELECT
                const select = group.querySelector('select');
                if (!selectedValue && select) {
                    selectedValue = select.value;
                    propertyLabel = group.dataset.label || select.name;
                }

                if (!selectedValue || !propertyLabel) return;

                // Remove existing hidden input
                const existingInput = form.querySelector(
                    `input[type="hidden"][data-custom-option="${propertyLabel}"]`
                );
                if (existingInput) existingInput.remove();

                // Create hidden input
                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = `${propertyLabel}`;
                hiddenInput.value = selectedValue;
                hiddenInput.setAttribute('data-custom-option', propertyLabel);

                form.appendChild(hiddenInput);
            });
        });
    }

    // 1) Initial page load
    document.addEventListener('DOMContentLoaded', () => {
        processInlineSvgs(document);
        processCustomOptionsValue(document);
    });

    document.addEventListener('change', function (e) {
      if (
          e.target.matches('input[type="radio"][data-ele="custom-option"]') ||
          e.target.matches('[data-ele="custom-options"] select')
      ) {
          const productPage = e.target.closest('product-page');
          if (productPage) {
              processCustomOptionsValue(productPage);
          }
      }
  });

    // 2) Expose a helper you can call manually after custom AJAX loads
    window.ShopifyInlineSvg = window.ShopifyInlineSvg || {};
    window.ShopifyInlineSvg.process = processInlineSvgs;

    // 3) Automatically handle dynamically inserted content via MutationObserver
    if ('MutationObserver' in window) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;

            // If the added node itself is a target
            if (node.matches && node.matches('[data-inline-svg]')) {
              processInlineSvgs(node);
            } else if (node.querySelectorAll) {
              // Or if it contains any targets inside
              processInlineSvgs(node);
            }
          });
        });
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }

    // 4) Handle Shopify Theme Editor section events
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) {
        processInlineSvgs(event.target);
      }
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (event.target) {
        processInlineSvgs(event.target);
      }
    });
  })();